import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Image, Col, Form, Button, Row } from "react-bootstrap";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import IconButton from "@material-ui/core/IconButton";
import SelectFilter from "../../../reusableComponents/selectFilter";

import isEmpty from "../../../../store/validation/is-Empty";
import { SET_SELECT_DATE_RANGE } from "../../../../store/types";
import { admin_pending_vendor_filter } from "../../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";

export const FilterAllVendorsPending = (props) => {
  const dispatch = useDispatch();
  const [dateQuery, setDateQuery] = useState({
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });

  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  useEffect(() => {
    dispatch(
      admin_pending_vendor_filter(
        auth.accessToken,
        true,
        dateQuery.startDate,
        dateQuery.endDate
      )
    );
  }, [dateQuery]);

  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
    dispatch({ type: SET_SELECT_DATE_RANGE, payload: data });
  };

  return (
    <React.Fragment>
      <>
        <div className="row super-admin-toptext-searchbar-icon align-items-end">
          <div className="col-6">
            <div className="col-9 p-0">
              <Form.Control
                type="text"
                placeholder="Search by Business name, restaurant type, primary email,contact number,id"
                onChange={props.onChange}
                value={props.search}
                className="amSearch"
              />
            </div>
          </div>
          <div className="col-6">
            <div className="d-flex justify-content-end">
              <div
                className="col-3 py-2 px-2"
                style={{ backgroundColor: "#EFEBFB" }}
              >
                <p className="f10-500 pb-3" style={{ color: "#6F32C9" }}>
                  Pending Requests
                </p>
                <p className="f16-700" style={{ color: "#6F32C9" }}>
                  {props.pendingCount <= 0 ? 0 : props.pendingCount}
                </p>
              </div>
              <div
                className="col-3 py-2 px-2 ml-3"
                style={{ backgroundColor: "#D8F3F4" }}
              >
                <p className="f10-500 pb-3" style={{ color: "#008B90" }}>
                  On Hold Requests
                </p>
                <p className="f16-700" style={{ color: "#008B90" }}>
                  {props.onHoldCount !== undefined ? props.onHoldCount : 0}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-6">
            <div className="row">
              <div className="col-3">
                <button
                  className="btn bg-transparent border-0 p-0"
                  type="button"
                  onClick={props.onAllHoldClick}
                >
                  <p
                    claasName="f11-500"
                    style={{
                      borderBottom: `${
                        props.activeButtonState
                          ? "0px solid"
                          : "2px solid #EE3A23"
                      }`,
                      color: `${
                        props.activeButtonState ? "#212121" : "#EE3A23"
                      }`,
                      opacity: `${props.activeButtonState ? "opacity5" : ""}`,
                    }}
                  >
                    All
                  </p>
                </button>
              </div>
              <div className="col-3">
                <button
                  className="btn bg-transparent border-0 p-0"
                  type="button"
                  onClick={props.onAllHoldClick}
                >
                  <p
                    claasName="f11-500"
                    style={{
                      borderBottom: `${
                        props.activeButtonState
                          ? "2px solid #EE3A23"
                          : "0px solid"
                      }`,
                      color: `${
                        props.activeButtonState ? "#EE3A23" : "#212121"
                      }`,
                      opacity: `${props.activeButtonState ? "" : "opacity5"}`,
                    }}
                  >
                    On-Hold
                  </p>
                </button>
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="row justify-content-end align-items-center">
              <div className="col-5">
                <div className="mr-3">
                  <SelectFilter
                    onDateChange={(data, type) =>
                      onDateChangeHandler(data, type)
                    }
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="d-flex align-items-center justify-content-between">
                  {props.sortMenuButton}
                  <div
                    className="f10-400"
                    align="center"
                    onClick={props.handleShowFilter}
                  >
                    <img
                      src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                      width="70px"
                    />
                    {/* <br />
                    Filter */}
                  </div>
                  {props.downloadButton}
                </div>
              </div>
            </div>
          </div>
        </div>
        {props.showFilter && (
          <div className="row">
            <div className="col-12">
              <div className="enWhiteBox mt-3">
                <Form className="row justify-content-between">
                  {/* <Col md={5}>
                    Date Range
                    <div
                      className="d-flex justify-content-start"
                      style={{ alignItems: "center" }}
                    >
                      <TextField
                        type="date"
                        variant="outlined"
                        onChange={props.onStartDateChange}
                        value={props.startDate}
                      />
                      &nbsp;To&nbsp;
                      <TextField
                        type="date"
                        variant="outlined"
                        onChange={props.onEndDateChange}
                        value={props.endDate}
                      />
                    </div>
                    <br />
                  </Col> */}
                  <Col md={5}>
                    <Form.Group>
                      <FormControl variant="outlined" className="w-100">
                        <InputLabel htmlFor="outlined-Restaurant-type">
                          Restaurant type
                        </InputLabel>
                        <Select
                          value={props.resType}
                          onChange={props.resTypeChangeHandler}
                          label="Restaurant type"
                          inputProps={{
                            name: "Restaurant_type",
                            id: "outlined-Restaurant-type",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {props.categoryList.map((data, index) => {
                            return (
                              <MenuItem value={data} key={index}>
                                {data}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <Form.Group>
                      <FormControl variant="outlined" className="w-100">
                        <TextField
                          variant="outlined"
                          label="Location"
                          fullWidth
                          value={props.location}
                          onChange={props.onChangeLocation}
                        />
                      </FormControl>
                    </Form.Group>
                    <Form.Group className="mb-0" controlId="formBasicCheckbox">
                      <Form.Check
                        type="checkbox"
                        label="Soft Onboarded"
                        className="f14-500"
                        onChange={props.onChangeSoftOnboarded}
                        value={props.softOnboarded}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <div className="d-flex align-items-center">
                      <Button
                        variant="outline-secondary"
                        className="btn-lg mr-4 px-5"
                        onClick={props.handleShowFilter}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-lg px-5"
                        onClick={props.handleSaveButton}
                      >
                        Search
                      </Button>
                    </div>
                  </Col>
                </Form>
              </div>
            </div>
          </div>
        )}
      </>
    </React.Fragment>
  );
};
